import Mosaic from 'mosaic-framework';

import '../components/navigation-bar';
import '../components/footer';
import '../components/round-button';
import '../components/code-segment';

import '../styles/docs.less';


export default new Mosaic({
    name: 'descendants-page',
    created() {
        window.scrollTo({ top: 0 });

        const menubtn = document.getElementById('menu-button');
        menubtn.style.display = 'block';

        if(menubtn.onclick) return;

        menubtn.onclick = () => {
            const menu = document.getElementById('doc-menu');
            menu.style.transform = 'translateX(0%)';
        }
    },
    view() {
        return html`<div class='doc-page'>
            <navigation-bar></navigation-bar>
            
            <h1 class='section-title' tabindex='0'>👶 Descendants</h1>
            <p class='section-text' tabindex='0'>
                The <b>descendants</b> property is used to display the child nodes of a
                Mosaic component. Because Mosaics are used as regular HTML tags, we can
                then place content inside of them like so:
            </p>
            <code-segment type='JS'>
                &lt;my-component&gt;
                <br>
                &nbsp;&nbsp;&nbsp;&nbsp;&lt;h1&gt;Content goes here&lt;/h1&gt;
                <br>
                &lt;/my-component&gt;
            </code-segment>
            <p class='section-text' tabindex='0'>
                The problem with this syntax is that you may not necessarily want that
                inner content to always be displayed in that component. So, what Mosaic
                does is it will group that inner content into a property called
                descendants which you can then decide whether or not to include in your
                component. To use the descendants property, simply include it in your 
                view function.
            </p>
            <code-segment type='JS'>
                ${"html`<div> ${this.descendants} </div>`"}
            </code-segment>
            <br>            

            <p class='section-text' tabindex='0' style='text-align:center;'>
                Next, we will look into how you can use external stylesheets
                to encapsulate styles while using the Shadow DOM.
            </p>
            <div style="text-align: center;">
                <round-button onclick='${() => this.router.send('/router')}'>
                    <ion-icon name="arrow-round-back"></ion-icon>
                    Mosaic Router
                </round-button>
                &nbsp;&nbsp;
                <round-button onclick='${() => this.router.send('/stylesheets')}'>
                    Stylesheets
                    <ion-icon name="arrow-round-forward"></ion-icon>
                </round-button>
                &nbsp;&nbsp;
            </div>

            <app-footer></app-footer>
        </div>`
    }
});